import "./MarketMapWidgetComponent.scss";
import template from "./MarketMapWidgetComponent.html";
import {IComponentOptions} from "angular";
import {ComponentCallback} from "../../../../../../../types/AngularJS";
import {CodeAndExchange} from "../../../../../../../instruments/types/CodeAndExchange";
import {WidgetDisplayMode} from "../../../../../models/WidgetDisplayMode";
import {ReplaySubject} from "rxjs";

export const MarketMapWidget = "tfMarketMapWidget";

export function marketMapWidget(): IComponentOptions {
    return {
        template,
        bindings: {
            displayMode: "<",
            onSecurityChanged: "&"
        },
        controllerAs: "ctrl",
        controller: MarketMapWidgetComponentController
    };
}

export class MarketMapWidgetComponentController {

    /** @input */
    public set displayMode(displayMode: WidgetDisplayMode | null) {
        if (displayMode != null) {
            this.displayMode$.next(displayMode);
        }
    }

    private readonly displayMode$ = new ReplaySubject<WidgetDisplayMode>(1);

    /** @output */
    public readonly onSecurityChanged: ComponentCallback;

    public securityChanged(security: CodeAndExchange) {
        this.onSecurityChanged({security});
    }
}
